export default __webpack_public_path__ + "static/at-52ad7c55809c68289ba514fbe6e1a2b8.svg";